export enum incomingCPPostMessages {
  closeIframe = 'iframe:close',
  appStartInit = 'app:startInit',
  appFinishInit = 'app:finishInit',
  updateCardImageStatus = 'card-compliance:updateCardImageStatus',
  notification = 'app:notification',
  transactionsRefresh = 'transactions:leads-tab:refresh',
  updateCurrentLead = 'transactions:leads-tab:updateCurrentLead',
  setHeight = 'iframe:setHeight',
}

export const outgoingCPPostMessages = {
  updateCardImageStatus: 'card-compliance:updateCardImageStatus',
};

export const CP_FRONT_REWRITE = 'back-office';

export const enum GroupTypes {
  countriesGroup = 'country',
  environmentGroup = 'environment',
}
